"use client";

import { HeroSection } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import { floorPlanTab } from "../../../../public/images/floor-plans";

const Hero = () => {
  const tC = useTranslations("common");
  const tH = useTranslations("individualFp.hero");

  return (
    <HeroSection
      image={floorPlanTab}
      alt={"Individueller Grundriss Beispiel"}
      tab={tC("individual")}
      title={tH("title")}
      text={tH("text")}
      linkTitle={tC("queryNow")}
      href={"#"}
    />
  );
};

export default Hero;
